import { useDispatch, useSelector } from 'react-redux';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import PerformanceCard from '../PerformanceCard';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceReservationCard } from '@/store/slices/components/dashboard/service';
import GenericBarChart from '../../Charts/GenericBarChart';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';

export default function ReservationsCreated() {
  const dispatch = useDispatch();
  const { reservationsCreated } = useSelector((state) => state.DashboardSlice);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const {
    loading,
    hasFetched,
    count,
    variation,
    icon,
    percentage_status,
    labels,
    datasets,
  } = reservationsCreated;

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceReservationCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'reservationsCreated',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard
      ref={ref}
      loading={loading || isStale}
      id="reservations-created"
    >
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'ReservationsCreated')}
      </PerformanceCard.Header>
      <PerformanceCard.Summary
        value={count}
        tendency={variation}
        icon={icon}
        percentageStatus={percentage_status}
      />
      <PerformanceCard.Content>
        <GenericBarChart labels={labels} datasets={datasets} />
      </PerformanceCard.Content>
    </PerformanceCard>
  );
}
